import DisclosureMenu from "./src/disclosureMenu.js";
import Menubar from "./src/menubar.js";
import Treeview from "./src/treeview.js";

export default {
  DisclosureMenu,
  Menubar,
  Treeview,
};
